<script lang="ts">
    import type {Document} from 'typings/portaro.be.types';
    import KpRecordTile from './KpRecordTile.svelte';
    import KpMasonryGrid from 'shared/layouts/masonry-grid/KpMasonryGrid.svelte';
    import KpMasonryGridItem from 'shared/layouts/masonry-grid/KpMasonryGridItem.svelte';

    export let records: Document[];
</script>

<KpMasonryGrid>
    {#each records as record(record.id)}
        <KpMasonryGridItem>
            <KpRecordTile {record}/>
        </KpMasonryGridItem>
    {/each}
</KpMasonryGrid>